import React from 'react';
import { LayoutGrid, BarChart3, Bell } from 'lucide-react';
interface TabsProps {
  activeTab: 'pipe' | 'metrics' | 'follow';
  onTabChange: (tab: 'pipe' | 'metrics' | 'follow') => void;
}
const TABS = [{
  id: 'pipe' as const,
  label: 'Pipeline',
  icon: LayoutGrid
}, {
  id: 'metrics' as const,
  label: 'Resultados',
  icon: BarChart3
}, {
  id: 'follow' as const,
  label: 'Seguir hoy',
  icon: Bell
}];
export function Tabs({
  activeTab,
  onTabChange
}: TabsProps) {
  return <div className="flex gap-1 my-5 bg-white p-1.5 rounded-2xl border border-line overflow-x-auto scrollbar-none shadow-sm" data-id="element-197">
      {TABS.map(tab => {
      const Icon = tab.icon;
      const isActive = activeTab === tab.id;
      return <button key={tab.id} onClick={() => onTabChange(tab.id)} style={isActive ? {
        backgroundColor: '#2B2B2B',
        color: '#ffffff'
      } : undefined} className={`flex-1 min-w-max border-none font-poppins font-bold text-[13.5px] px-4 py-2.5 rounded-xl cursor-pointer whitespace-nowrap transition-all flex items-center justify-center gap-2 ${isActive ? 'shadow-sm' : 'bg-transparent text-[#8a8175] hover:text-[#2B2B2B] hover:bg-cream-2/50'}`} data-id="element-198">
            <Icon className="w-4 h-4" strokeWidth={2.4} data-id="element-199" />
            {tab.label}
          </button>;
    })}
    </div>;
}